import { palette } from '@kareo/design-system';
export var appointmentStatusIds = {
    0: { status: 'Unknown', color: palette.text.disabled },
    1: { status: 'Scheduled', color: palette.text.disabled },
    2: { status: 'Reminder Sent', color: palette.text.disabled },
    3: { status: 'Confirmed', color: palette.success.main },
    4: { status: 'Arrived', color: palette.text.disabled },
    5: { status: 'Roomed', color: palette.text.disabled },
    6: { status: 'Checked Out', color: palette.text.disabled },
    7: { status: 'Needs to be Rescheduled', color: palette.text.disabled },
    8: { status: 'Checked In', color: palette.text.disabled },
    9: { status: 'No Show', color: palette.error.main },
    10: { status: 'Cancelled', color: palette.error.main },
    11: { status: 'Rescheduled', color: palette.error.main },
    12: { status: 'Tentative', color: palette.text.disabled },
};
